import {isNil} from 'ramda';

export function capturePdfPreviewAnchor(viewport: HTMLElement, pages: HTMLElement[]) {
  const centerX = viewport.scrollLeft + viewport.clientWidth / 2;
  const centerY = viewport.scrollTop + viewport.clientHeight / 2;
  let nearest: HTMLElement | undefined;
  let distance = Infinity;

  for (const page of pages) {
    if (page.offsetWidth === 0 || page.offsetHeight === 0) {
      continue;
    }
    const gap = Math.max(page.offsetTop - centerY, centerY - page.offsetTop - page.offsetHeight, 0);
    if (gap < distance) {
      nearest = page;
      distance = gap;
    }
  }

  if (isNil(nearest)) {
    return null;
  }
  // In a page gap or beside a narrow centered page, anchor its nearest document edge.
  return {
    page: nearest,
    x: Math.max(0, Math.min(1, (centerX - nearest.offsetLeft) / nearest.offsetWidth)),
    y: Math.max(0, Math.min(1, (centerY - nearest.offsetTop) / nearest.offsetHeight)),
  };
}
